import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { useForm } from 'react-hook-form'
import { BpLink } from '../../../../shared/components/text/link/BpLink'
import { FormHTMLAttributes } from 'react'
import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { useTranslation } from 'react-i18next'
import { GoogleButton } from '../../../../widgets/utility/GoogleButton'
import { EMAIL_REGEX } from '../../../../shared/consts/RegularExpressions.const'
import clsx from 'clsx'

import styles from './LoginForm.module.scss'

export interface ILoginFormData {
  email: string
  password: string
}

export interface ILoginFormProps extends FormHTMLAttributes<HTMLFormElement> {
  submitHandler?: (data: ILoginFormData) => void
  isFetching?: boolean
}

export const LoginForm = ({ submitHandler, isFetching = false, ...formProps }: ILoginFormProps) => {
  const { t } = useTranslation()
  const {
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm<ILoginFormData>({
    mode: 'onChange',
  })

  return (
    <>
      <h2 className={clsx(styles.title)}>{t('pages.auth.logIn')}</h2>
      {
        {
          bluepear: (
            <>
              <GoogleButton />
              <div className={clsx(styles.divider)}>
                <div className={clsx(styles.dividerText)}>or</div>
              </div>
            </>
          ),
          robuscan: null,
          default: null,
        }[process.env.REACT_APP_PROJECT ?? 'default']
      }
      <form
        {...formProps}
        className={clsx(styles.form)}
        onSubmit={handleSubmit((data: ILoginFormData) => {
          if (submitHandler) submitHandler(data)
        })}
      >
        <BpInput
          required
          error={errors.email?.message}
          fieldSize='lg'
          label={t('pages.auth.email')}
          {...register('email', {
            required: t('fields.validate.emailRequired'),
            pattern: {
              value: EMAIL_REGEX,
              message: t('fields.validate.enterValidEmail'),
            },
          })}
        ></BpInput>
        <BpInput
          required
          error={errors.password?.message}
          fieldSize='lg'
          label={t('pages.auth.password')}
          type='password'
          {...register('password', { required: t('fields.validate.required') })}
        ></BpInput>
        <div className={clsx(styles.linksRow)}>
          {/* TODO refactoring <BpCheckbox {...register('remember')} label='Remember me'></BpCheckbox> */}
          <span className={clsx(styles.links)}>
            <BpLink to='/auth/reset-password'>{t('pages.auth.resetPassword')}</BpLink>
            {
              {
                bluepear: (
                  <BpAnchor href='mailto:sales@bluepear.co'>
                    {t('pages.auth.contactSupport')}
                  </BpAnchor>
                ),
                robuscan: null,
                default: null,
              }[process.env.REACT_APP_PROJECT ?? 'default']
            }
          </span>
        </div>
        <div className={clsx(styles.submitRow)}>
          <BpButton
            className={clsx(styles.submitBtn)}
            disabled={!isValid}
            loading={isFetching}
            size='lg'
            type='submit'
          >
            {t('pages.auth.buttons.login')}
          </BpButton>
        </div>
        {process.env.REACT_APP_PROJECT !== 'robuscan' && (
          <div>
            <p>
              {t('pages.auth.dontHaveAccount')}{' '}
              <BpLink to={'/auth/signup'}>{t('pages.auth.signUp')}</BpLink>
            </p>
          </div>
        )}
      </form>
    </>
  )
}
